import { Button, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import RichTextField from 'src/app/shared/components/common/rich-text-field'
import ActionConfirmationModal from 'src/app/shared/components/modal/action-confirmation-modal'
import { ModalWarningIcon } from 'src/assets/icons'

interface Props {
  isOpen: boolean
  onClose: () => void
  formatName: string
}

function AdditionalChangedModal(props: Props) {
  const { isOpen, onClose, formatName = '' } = props
  const { t } = useTranslation()

  return (
    <ActionConfirmationModal
      icon={<ModalWarningIcon />}
      title={
        <Typography className='modal-title'>
          {t('FileMappingSetup:copyFileMapping.modal.additionalChanged.title')}
        </Typography>
      }
      onClose={onClose}
      isOpen={isOpen}
      descriptionType='string'
      description={
        <RichTextField
          richText={t('FileMappingSetup:copyFileMapping.modal.additionalChanged.description', { formatName })}
        />
      }
      footer={[
        <Button size='middle' type='primary' onClick={onClose}>
          {t('common:ok')}
        </Button>,
      ]}
    />
  )
}

export default AdditionalChangedModal
